import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-leads-partners-upgrade-page',
    templateUrl: './leads-partners-upgrade.component.html',
    styleUrls: ['./leads-partners-upgrade.component.scss'],
})
export class LeadsPartnersUpgradeComponent implements OnInit {
    headline: string;
    shortOverview: string;
    selligPointHeader: string;
    logoPlaceholder: string;
    moduleShortDescription: string;
    backgroundColor: string;

    constructor() {}
    ngOnInit() {
        this.setupgradepage();
    }

    setupgradepage() {
        this.headline = 'Maximize the quality of your leads and referral partners';
        this.shortOverview =
            'A must-have module for Purchase transaction business and the Consumer Direct channel.';
        this.selligPointHeader =
            'Know where your business is coming from so you can ask for more of it';
        this.logoPlaceholder = 'src/assets/images/upgrade_thumbnails/leads_upgrade.png';
        this.moduleShortDescription =
            'Analyze call volume, lead quality, builder business, and real estate agent engagement.  Track pull-through from lead-to-app and app-to-fund.';
        this.backgroundColor = '#e0f3f3';
    }
}
